import { useEffect, useState } from "react";
import env, { findBox } from "../../env";
import PostReq from "../../utils/PostReq";
import { useRef } from "react";
function QuickShemsh(props) {
  const { setSelectedShemsh, SelectedShemsh } = props;
  const [showDrop, setShowDrop] = useState(0);
  const [query, setQuery] = useState("");
  const [data, setData] = useState();
  useEffect(() => {
    const timeOutId = setTimeout(() => SearchShemsh(query), 1000);
    return () => clearTimeout(timeOutId);
    //props.setSearch
  }, [query]);
  const SearchShemsh = async (search) => {
    const result = await PostReq({
      method: "Post",
      url: "/panel/product/list-shemsh",
      body: { title: search },
    });
    setData("");
    setTimeout(() => setData(result), 200);
  };
  // useEffect(() => {
  //   SearchShemsh();
  // }, []);
  // Ref for the wrapper
  const wrapperRef = useRef(null);

  useEffect(() => {
    function handleClickOutside(event) {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        setShowDrop(0);
      }
    }
    if (showDrop) {
      document.addEventListener("mousedown", handleClickOutside);
    }
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showDrop]);

  return (
    <div ref={wrapperRef}>
      {SelectedShemsh ? (
        <div className="code-input-wrapper">
          <p>{SelectedShemsh.title}</p>
          <i
            class="fa fa-times"
            aria-hidden="true"
            onClick={() => setSelectedShemsh("")}
          ></i>
        </div>
      ) : (
        <div className="code-input-wrapper">
          <input
            className="dp-input"
            type="text"
            placeholder="جستجوی شمش "
            onChange={(e) => setQuery(e.target.value)}
            onFocus={() => setShowDrop(1)}
          />
          <i
            className="fa-solid fa-angle-down"
            onClick={() => setShowDrop(1)}
          ></i>
        </div>
      )}

      {query || showDrop ? (
        <div className="code-drop-menu">
          {data ? (
            data.filter &&
            data.filter.map((item, i) => (
              <div
                key={i}
                className="menu-item"
                onClick={(e) => {
                  setSelectedShemsh(item);
                  setQuery("");
                  setShowDrop(0);
                }}
              >
                <div className="item-img">
                  <img src={env.siteApiUrl + item.imageUrl} alt="" />
                </div>
                <div className="item-info">
                  <div className="item-p">
                    <p>{item.title}</p>
                  </div>
                  <div className="item-amount">
                    <p>{item.sku}</p>
                    <p>{item.weight}</p>
                    <p>{item.isMojood ? "موجود" : "ناموجود"}</p>
                  </div>
                </div>
              </div>
            ))
          ) : (
            <div className="roader">{env.loader}</div>
          )}
        </div>
      ) : (
        <></>
      )}
    </div>
  );
}
export default QuickShemsh;
